import CategoryHubsCarousel from './CategoryHubsCarousel'

export default CategoryHubsCarousel
